import { graphql, useStaticQuery } from "gatsby";

export const useFilteredPublicationsByLocationSlug = ({
  locationPageSlugs = []
} = {}) => {
  const { publicationCollection, publicationsList } = useStaticQuery(graphql`
    {
      publicationCollection: allWp {
        nodes {
          publications: acfOptionsPublications {
            ...WpPublicationsFragment
          }
        }
      }
      publicationsList: allWpPublication {
        ...WpPublicationFragment
      }
    }
  `);

  const flattenPublications = publicationCollection?.nodes?.flatMap(
    (list) => list?.publications?.publications
  );

  const flattenedPublicationsList = publicationsList?.nodes?.flatMap(
    (list) => list?.acfPublications
  );

  const publist = flattenedPublicationsList.filter((publication) =>
    locationPageSlugs.includes(publication?.optPublicationLocation?.[0]?.slug)
  );

  const result = {
    title: flattenPublications[0]?.publicationsLabel,
    content: flattenPublications[0]?.publicationsContent,
    list: publist ?? [],
    debug: flattenPublications
  };

  return result ?? [];
};
